export const secondInMilliseconds = 1000;
export const hourInMinutes = 60;
export const minuteInSeconds = 60;
export const dayInHours = 24;
export const minuteInMilliseconds = secondInMilliseconds * minuteInSeconds;
export const hourInMilliseconds = minuteInMilliseconds * hourInMinutes;
export const dayInMilliseconds = hourInMilliseconds * dayInHours;
